var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.674 0H1.66C.743 0 0 .743 0 1.66v10.014c0 .916.743 1.66 1.66 1.66h10.014c.916 0 1.66-.744 1.66-1.66V1.66c0-.917-.744-1.66-1.66-1.66zm6.576 1.309l-3.806 2.625v5.465l3.806 2.622c.736.507 1.75-.01 1.75-.896v-8.92c0-.882-1.01-1.403-1.75-.896z",
    transform: "translate(2 5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockVideo);
export default __webpack_public_path__ + "static/media/block-video.2b9b8c7b95b84a5383297ae62e33541b.svg";
export { ForwardRef as ReactComponent };